import React, { Fragment, useState } from 'react';
import { Table } from 'react-bootstrap';
import classNames from 'classnames';
import { ProductSpc } from 'api/products/_requests';

export interface SpecificationTableProps {
  title: string;
  data: ProductSpc[];
  inBox: string[];
}

const COLLAPSED_ROWS = 2;

const SpecificationTable = ({
  title,
  data,
  inBox
}: SpecificationTableProps) => {
  const [expanded, setExpanded] = useState(false);
  const visibleRows = expanded ? data : data.slice(0, COLLAPSED_ROWS);
  const canToggle = data.length > COLLAPSED_ROWS || inBox.length > 0;

  return (
    <>
      <h5 className="mb-0 fw-semibold">{title}</h5>

      <Table>
        <thead>
          <tr>
            <th style={{ width: '40%' }} />
            <th style={{ width: '60%' }} />
          </tr>
        </thead>
        <tbody>
          {visibleRows.map(item => (
            <tr key={item.header}>
              <td
                className={classNames('bg-body-highlight', {
                  'align-middle': !Array.isArray(item.value)
                })}
              >
                <h6
                  className={classNames(
                    'mb-0 text-body text-uppercase fw-bolder px-4 fs--1 lh-sm',
                    { 'mt-1': Array.isArray(item.value) }
                  )}
                >
                  {item.header}
                </h6>
              </td>
              <td className="px-5 mb-0">
                {Array.isArray(item.value)
                  ? item.value.map(v => (
                      <Fragment key={v}>
                        {v}
                        <br />
                      </Fragment>
                    ))
                  : item.value}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {expanded && inBox.length > 0 && (
        <div>
          <h4 className="mb-3 ms-4 fw-bold">In The Box</h4>
          {inBox.map((item, idx) => (
            <p
              key={idx}
              className={`lh-sm mb-0 py-3 px-4 border-translucent border-top ${
                idx === inBox.length - 1 ? 'border-bottom' : ''
              }`}
            >
              {item}
            </p>
          ))}
        </div>
      )}

      {canToggle && (
        <button
          type="button"
          className="btn btn-link p-0 fw-semibold mb-2"
          onClick={() => setExpanded(p => !p)}
        >
          {expanded ? 'See less' : 'See more'}
        </button>
      )}
    </>
  );
};

export default SpecificationTable;
